export function FooterImage() {
    return <img src='/include/images/auth/mountain-landscape.svg' alt='mountain landscape' />;
}
